export default Object.freeze({
  Scheduled: 1,
  Active: 2,
  Exhausted: 3,
  Ended: 4,
});
